import { isApiError } from '@repletoryreach/sdk-api';

/**
 * The password rules the identity service enforces since 2 October 2026: at
 * least 12 characters, no rule about capitals, digits or symbols, and none of
 * the most common leaked passwords (checked on the server, which refuses with
 * `reason: "breached"`). These mirror the tenant console's `lib/password.ts`
 * so the two consoles cannot drift into asserting different rules for the
 * same service.
 */

export const PASSWORD_MIN_LENGTH = 12;

export interface PasswordRule {
  /** Catalogue key describing the rule. */
  key: string;
  met: boolean;
}

export function passwordRules(password: string): PasswordRule[] {
  return [{ key: 'settings.security.password.rules.length', met: password.length >= PASSWORD_MIN_LENGTH }];
}

export function isPasswordValid(password: string): boolean {
  return passwordRules(password).every((rule) => rule.met);
}

/** The sentence for a password identity refused, or null when the refusal was about something else. */
export function passwordRefusalMessage(err: unknown, t: (key: string) => string): string | null {
  if (!isApiError(err)) return null;
  const reason = (err.body as { error?: { reason?: string } } | null)?.error?.reason;
  if (reason === 'breached') return t('password.errors.breached');
  if (reason === 'too_short') return t('password.errors.tooShort');
  return null;
}
